import { useEffect } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Container, GlobalStyle } from "./styles";
import Navbar from "./components/Navbar";
import HomePage from "./components/HomePage";
import Research from "./components/Research";
import Writing from "./components/Writing";
import ResearchAdvice from "./components/posts/ResearchAdvice";
import Photos from "./components/Photos";
import Stats from "./components/Stats";

/* Start each new page at the top, unless the URL points at a section. */
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <Router>
      <GlobalStyle />
      <ScrollToTop />
      <Navbar />
      <Container>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/research" element={<Research />} />
          <Route path="/writing" element={<Writing />} />
          <Route path="/writing/research-advice" element={<ResearchAdvice />} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/stats" element={<Stats />} />
          {/* Old URLs keep working */}
          <Route path="/posts" element={<Navigate to="/writing" replace />} />
          <Route path="/posts/research-advice" element={<Navigate to="/writing/research-advice" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Container>
    </Router>
  );
}